<template>
	<div class="m-setup">
		<div v-if="!isMiniprogram && !isTaobao" class="setup-alert">
			<i class="el-icon-info"></i>
			提示：先填写拼多多登录账户，以 pdd 开头的那个账户，之后再点击授权。
		</div>

		<div v-if="loading" v-loading="loading" class="setup-loading"></div>

		<el-form v-else-if="formReady" ref="form" :model="form" :key="formKey" label-width="220px" class="setup-form">
			<!-- 基础配置 -->
			<div class="form-section">
				<template v-if="isMiniprogram">
					<el-form-item label="小程序店铺名称" required>
						<div class="field-wrap">
							<el-input :value="miniprogramShopName" placeholder="店铺名称" disabled />
						</div>
					</el-form-item>

					<el-form-item label="API Key">
						<div class="field-wrap">
							<el-input :value="maskedApiKey" disabled />
							<p class="field-tip">API Key 由小程序端生成，绑定后在此展示（脱敏）</p>
						</div>
					</el-form-item>

					<el-form-item label="绑定时间">
						<div class="field-wrap">
							<el-input :value="formatBindTime(form.create_time)" disabled />
						</div>
					</el-form-item>
				</template>

				<template v-else-if="isTaobao">
					<el-form-item label="淘宝店铺名称" required>
						<div class="field-wrap">
							<el-input :value="taobaoShopName" placeholder="店铺名称" disabled />
							<p class="field-tip">店铺在淘宝平台的显示名称</p>
						</div>
					</el-form-item>

					<el-form-item label="淘宝店铺编号">
						<div class="field-wrap">
							<el-input :value="taobaoShopId" placeholder="店铺编号" disabled />
						</div>
					</el-form-item>
				</template>

				<template v-else>
					<el-form-item label="拼多多店铺名称" required>
						<div class="field-wrap">
							<el-input :value="form.mall_name" placeholder="请输入店铺名称" disabled />
							<p class="field-tip">店铺在拼多多平台的显示名称</p>
						</div>
					</el-form-item>

					<el-form-item label="拼多多账户(pdd开头)" required>
						<div class="field-wrap">
							<el-input v-model="form.pdd_account" placeholder="pdd89574671794" disabled />
						</div>
					</el-form-item>
				</template>

				<el-form-item label="自动发货" required>
					<div class="field-wrap">
						<el-select :value="fieldVal('auto_ship')" placeholder="请选择" @input="fieldSet('auto_ship', $event)">
							<el-option v-for="item in configData.autoShipData" :key="item.value" :label="item.label" :value="item.value" />
						</el-select>
						<p class="field-tip">{{ autoShipTip }}</p>
					</div>
				</el-form-item>

				<el-form-item label="自动发货_未录入渠道退货地址" required>
					<div class="field-wrap">
						<el-select :value="fieldVal('auto_ship_no_return_addr')" placeholder="请选择" @input="fieldSet('auto_ship_no_return_addr', $event)">
							<el-option v-for="item in configData.autoShipData" :key="item.value" :label="item.label" :value="item.value" />
						</el-select>
						<p class="field-tip">推荐：自动发货。当售后规则判定为退渠道时，若店铺未录入渠道退货地址，是否自动发货</p>
					</div>
				</el-form-item>
			</div>

			<div class="setup-notice">
				<i class="el-icon-warning-outline"></i>
				《自动配置商品规则》谨慎选择，自动配置商品规则后，会直接更新线上商品的库存或价格，若不确定规则，可先选择不配置，后续可在商品列表进行手动配置
			</div>

			<div class="form-section">
				<el-form-item label="自动配置商品规则" required>
					<div class="field-wrap">
						<el-select :value="fieldVal('auto_config_strategy')" placeholder="请选择" @input="fieldSet('auto_config_strategy', $event)">
							<el-option v-for="item in configData.autoConfigStrategyData" :key="item.value" :label="item.label" :value="item.value" />
						</el-select>
						<p class="field-tip">推荐：通用安全库存规则改价格。下载到新商品后自动将商品同步规则设置为设定的规则</p>
					</div>
				</el-form-item>

				<el-form-item label="自动配置商品更新库存" required>
					<div class="field-wrap">
						<el-select :value="fieldVal('auto_config_stock_sync')" placeholder="请选择" @input="fieldSet('auto_config_stock_sync', $event)">
							<el-option v-for="item in configData.autoConfigStockSyncData" :key="item.value" :label="item.label" :value="item.value" />
						</el-select>
						<p class="field-tip">推荐：自动配置商品更新库存。下载到新商品后自动将商品同步库存设置为同步</p>
					</div>
				</el-form-item>

				<el-form-item label="排序号" required>
					<div class="field-wrap">
						<el-input-number :value="fieldVal('sort_order')" :controls="false" placeholder="0" @input="fieldSet('sort_order', $event)" />
						<p class="field-tip">多个店铺时，选择店铺下拉框的显示次序，若只有 1 个店铺可以默认 0</p>
					</div>
				</el-form-item>
			</div>

			<el-collapse v-model="activeCollapse" class="setup-collapse">
				<el-collapse-item title="商品 SKU 外部编码规则" name="sku">
					<el-form-item label="规则类型" required>
						<div class="field-wrap field-wrap--wide">
							<el-select
								:value="fieldVal('sku_outer_id_rule')"
								placeholder="请选择"
								popper-class="sku-outer-id-rule-popper"
								@input="fieldSet('sku_outer_id_rule', $event)"
							>
								<el-option v-for="item in configData.skuOuterIdRuleData" :key="item.value" :label="item.label" :value="item.value" />
							</el-select>
							<p class="field-tip">按商家编码中的分隔符解析款号和尺码。平台默认与竖杠解析结果相同；减号只拆最后一个分隔段。</p>
						</div>
					</el-form-item>
				</el-collapse-item>

				<el-collapse-item title="售后规则" name="aftersale">
					<el-form-item label="自动申请平台订单售后" required>
						<div class="field-wrap">
							<el-select :value="fieldVal('auto_apply_aftersale')" placeholder="请选择" @input="fieldSet('auto_apply_aftersale', $event)">
								<el-option v-for="item in configData.autoDownloadAftersaleData" :key="item.value" :label="item.label" :value="item.value" />
							</el-select>
							<p class="field-tip">推荐：启用。启动功能后，满足自动申请 平台订单 售后条件的则自动申请</p>
						</div>
					</el-form-item>

					<el-form-item :label="aftersaleRefundLabel" required>
						<div class="field-wrap">
							<el-select :value="fieldVal('aftersale_auto_refund')" placeholder="请选择" @input="fieldSet('aftersale_auto_refund', $event)">
								<el-option v-for="item in configData.aftersaleAutoRefund" :key="item.value" :label="item.label" :value="item.value" />
							</el-select>
							<p class="field-tip">{{ aftersaleRefundTip }}</p>
						</div>
					</el-form-item>
				</el-collapse-item>
			</el-collapse>

			<div class="form-actions">
				<el-button type="primary" :loading="saving" @click="onSubmit">保存</el-button>
			</div>
		</el-form>
	</div>
</template>

<script>
import configData from './configObj'
import {
	buildFieldPaths,
	getByPath,
	setByPath,
} from './mSetupForm'
import { maskApiKey, getShopDisplayName, SHOP_TYPE_MINIPROGRAM, SHOP_TYPE_TAOBAO } from '@/constants/retailPlatform'

function cloneData(data) {
	return JSON.parse(JSON.stringify(data))
}

function ensureArrayField(obj, key) {
	if (!obj || typeof obj !== 'object') {
		return
	}
	if (!Array.isArray(obj[key])) {
		if (typeof obj[key] === 'string' && obj[key]) {
			try {
				const parsed = JSON.parse(obj[key])
				obj[key] = Array.isArray(parsed) ? parsed : obj[key].split(',').map(function(item) { return item.trim() }).filter(Boolean)
			} catch (e) {
				obj[key] = obj[key].split(',').map(function(item) { return item.trim() }).filter(Boolean)
			}
		} else if (obj[key] == null || obj[key] === '') {
			obj[key] = []
		}
	}
}

function normalizeAutoManualValue(val) {
	if (val == null || val === '') {
		return val
	}
	const map = {
		1: 'auto',
		2: 'manual',
		'1': 'auto',
		'2': 'manual',
	}
	return map[val] != null ? map[val] : val
}

function normalizeAutoManualFields(form, fieldPaths, fieldKeys) {
	fieldKeys.forEach(function(fieldKey) {
		const path = fieldPaths[fieldKey]
		if (!path) {
			return
		}
		const val = getByPath(form, path)
		if (val != null && val !== '') {
			setByPath(form, path, normalizeAutoManualValue(val))
		}
	})
}

const SKU_OUTER_ID_RULE_VALUES = ['system_default', '|', '/', '-', 'none']

function normalizeSkuOuterIdRuleValue(val) {
	if (val == null || val === '') {
		return 'system_default'
	}

	if (SKU_OUTER_ID_RULE_VALUES.indexOf(val) !== -1) {
		return val
	}

	const wordMap = {
		pipe: '|',
		slash: '/',
		dash: '-',
	}
	if (wordMap[val] != null) {
		return wordMap[val]
	}

	const num = Number(val)
	if (!isNaN(num)) {
		if (num === 4) {
			return 'none'
		}
		const numMap = {
			0: '|',
			1: '/',
			2: '-',
			3: 'none',
		}
		if (numMap[num] != null) {
			return numMap[num]
		}
	}

	return 'system_default'
}

function normalizeSkuFields(form, fieldPaths) {
	const rulePath = fieldPaths.sku_outer_id_rule
	if (!rulePath) {
		return
	}

	let ruleVal = getByPath(form, rulePath)
	if (ruleVal == null || ruleVal === '') {
		const legacyRuleType = getByPath(form, resolveLegacySkuPath(form, 'sku_rule_type'))
		const legacyConnector = getByPath(form, resolveLegacySkuPath(form, 'sku_connector'))

		if (legacyRuleType === 0 || legacyRuleType === '0') {
			ruleVal = 'system_default'
		} else if (legacyRuleType === 1 || legacyRuleType === '1') {
			ruleVal = legacyConnector != null ? legacyConnector : '|'
		}
	}

	setByPath(form, rulePath, normalizeSkuOuterIdRuleValue(ruleVal))
}

function resolveLegacySkuPath(form, fieldKey) {
	if (form.sku && Object.prototype.hasOwnProperty.call(form.sku, fieldKey)) {
		return 'sku.' + fieldKey
	}
	if (Object.prototype.hasOwnProperty.call(form, fieldKey)) {
		return fieldKey
	}
	return fieldKey
}

function ensureArrayAtPath(form, path) {
	const parts = path.split('.')
	const key = parts.pop()
	let obj = form
	for (let i = 0; i < parts.length; i++) {
		if (!obj || typeof obj !== 'object') {
			return
		}
		obj = obj[parts[i]]
	}
	ensureArrayField(obj, key)
}

export default {
	name: 'MSetup',
	inject: {
		retailShop: { default: null },
	},
	data() {
		return {
			configData,
			saving: false,
			activeCollapse: ['sku', 'aftersale'],
			form: {},
			formKey: '',
			fieldPaths: {},
		}
	},
	watch: {
		'retailShop.shopDetail': {
			immediate: true,
			handler(detail) {
				if (detail) {
					this.applyShopDetail(detail)
				}
			},
		},
	},
	computed: {
		isMiniprogram() {
			if (this.$route.path.indexOf('/StoreConfig/miniprogram/') === 0) {
				return true
			}
			if (this.retailShop && this.retailShop.shopDetail && Number(this.retailShop.shopDetail.type) === SHOP_TYPE_MINIPROGRAM) {
				return true
			}
			return false
		},
		isTaobao() {
			if (this.$route.path.indexOf('/StoreConfig/taobao/') === 0) {
				return true
			}
			if (this.retailShop && this.retailShop.shopDetail && Number(this.retailShop.shopDetail.type) === SHOP_TYPE_TAOBAO) {
				return true
			}
			return false
		},
		taobaoShopName() {
			return getShopDisplayName(this.form)
		},
		taobaoShopId() {
			return (this.form && this.form.shop_id) || '-'
		},
		autoShipTip() {
			if (this.isMiniprogram) {
				return '推荐：自动发货。当平台订单有物流信息时，自动回传小程序订单物流单号'
			}
			if (this.isTaobao) {
				return '推荐：自动发货。当平台订单有物流信息时，自动更新淘宝平台订单物流单号'
			}
			return '推荐：自动发货。当 平台订单有物流信息时，自动更新拼多多平台订单物流单号'
		},
		aftersaleRefundLabel() {
			if (this.isMiniprogram) {
				return '平台售后自动退款'
			}
			if (this.isTaobao) {
				return '淘宝售后自动退款'
			}
			return '拼多多售后自动退款'
		},
		aftersaleRefundTip() {
			if (this.isMiniprogram) {
				return '推荐：自动确认。当对应平台订单退货成功，将自动确认退款给买家'
			}
			if (this.isTaobao) {
				return '推荐：自动确认。当对应平台订单退货成功，淘宝售后单将自动确认退款给买家'
			}
			return '推荐：自动确认。当对应 平台订单退货成功，拼多多售后单将自动确认退款给买家'
		},
		miniprogramShopName() {
			return getShopDisplayName(this.form)
		},
		maskedApiKey() {
			return maskApiKey(this.form && this.form.access_token)
		},
		loading() {
			return !!(this.retailShop && this.retailShop.shopDetailLoading)
		},
		formReady() {
			return !!(this.form && this.form.id != null && this.form.id !== '')
		},
	},
	methods: {
		formatBindTime(time) {
			if (time == null || time === '') {
				return '-'
			}
			if (typeof time === 'number' || /^\d+$/.test(String(time))) {
				let timestamp = Number(time)
				if (String(timestamp).length === 10) {
					timestamp = timestamp * 1000
				}
				return this.$moment(timestamp).format('YYYY-MM-DD HH:mm:ss')
			}
			return this.$moment(time).format('YYYY-MM-DD HH:mm:ss')
		},
		fieldVal(fieldKey) {
			return getByPath(this.form, this.fieldPaths[fieldKey])
		},
		fieldSet(fieldKey, value) {
			setByPath(this.form, this.fieldPaths[fieldKey], value, this)
		},
		applyShopDetail(detail) {
			const form = cloneData(detail)

			if (!form.pdd_account) {
				form.pdd_account = detail.pdd_login || detail.account || detail.pdd_uid || ''
			}

			const fieldPaths = buildFieldPaths(form)
			normalizeAutoManualFields(form, fieldPaths, [
				'auto_ship',
				'auto_ship_no_return_addr',
			])
			normalizeSkuFields(form, fieldPaths)

			this.fieldPaths = fieldPaths
			this.form = form
			this.formKey = String(form.id || Date.now())
		},
		buildSavePayload() {
			if (!this.form || !this.form.id) {
				return null
			}
			return cloneData(this.form)
		},
		onSubmit() {
			const payload = this.buildSavePayload()
			if (!payload) {
				this.$message.warning('店铺详情加载中，请稍后再保存')
				return
			}
			this.saving = true
			this.$axios.post('api/retail_shop/config_save', payload).then(res => {
				if (res.data.code == 0) {
					this.$message.success('保存成功')
					if (this.retailShop && typeof this.retailShop.fetchShopDetail === 'function') {
						this.retailShop.fetchShopDetail(payload.id, true)
					}
				} else {
					this.$message.error(res.data.message || '保存失败')
				}
			}).catch(err => {
				console.log(err)
				this.$message.error('保存失败')
			}).finally(() => {
				this.saving = false
			})
		}
	}
}
</script>

<style scoped lang="less">
.m-setup {
	max-width: 960px;
	padding: 8px 16px 32px;
}

.setup-loading {
	min-height: 320px;
}

.setup-alert {
	display: flex;
	align-items: flex-start;
	gap: 8px;
	padding: 10px 14px;
	margin-bottom: 24px;
	font-size: 13px;
	color: #606266;
	background: #f4f4f5;
	border-radius: 6px;
	line-height: 1.5;

	i {
		margin-top: 2px;
		color: #909399;
	}
}

.setup-notice {
	display: flex;
	align-items: flex-start;
	gap: 8px;
	padding: 10px 14px;
	margin: 8px 0 20px;
	font-size: 13px;
	color: #409eff;
	background: #ecf5ff;
	border-radius: 6px;
	line-height: 1.5;

	i {
		margin-top: 2px;
		flex-shrink: 0;
	}
}

.form-section {
	margin-bottom: 8px;
}

.setup-collapse {
	margin-bottom: 24px;
	border: none;

	/deep/ .el-collapse-item__header {
		height: 44px;
		padding: 0 4px;
		font-size: 14px;
		font-weight: 500;
		color: #303133;
		background: transparent;
		border-bottom: 1px solid #ebeef5;
	}

	/deep/ .el-collapse-item__wrap {
		border-bottom: 1px solid #ebeef5;
	}

	/deep/ .el-collapse-item__content {
		padding: 20px 4px 4px;
	}

	.panel-tips {
		margin-bottom: 16px;
		padding: 10px 14px;
		background: #fafafa;
		border-radius: 6px;

		p {
			margin: 0;
			font-size: 12px;
			color: #909399;
			line-height: 1.6;

			& + p {
				margin-top: 4px;
			}
		}
	}
}

.setup-form {
	/deep/ .el-form-item {
		margin-bottom: 20px;
	}

	/deep/ .el-form-item__label {
		font-size: 12px;
		color: #606266;
		line-height: 32px;
		padding-right: 16px;
	}

	/deep/ .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label::before {
		color: #f56c6c;
	}
}

.field-wrap {
	max-width: 520px;

	.el-input,
	.el-select,
	.el-input-number {
		width: 100%;
	}

	/deep/ .el-input-number .el-input__inner {
		text-align: left;
	}

	&--inline {
		max-width: none;
	}

	&--wide {
		max-width: 640px;
	}
}

.inline-rule-item {
	/deep/ .el-form-item__content {
		line-height: 32px;
	}
}

.inline-rule {
	font-size: 13px;
	color: #606266;
	line-height: 32px;
	word-break: break-word;

	> span {
		vertical-align: middle;
	}

	.inline-select,
	.inline-number {
		display: inline-block;
		vertical-align: middle;
		margin: 0 2px;
	}

	.inline-select {
		width: 100px;

		/deep/ .el-input {
			width: 100px;
		}
	}

	.inline-number {
		width: 100px;

		/deep/ .el-input {
			width: 100px;
		}
	}
}

.field-tip {
	margin: 6px 0 0;
	font-size: 11px;
	color: #909399;
	line-height: 1.5;

	&--warn {
		color: #e6a23c;
	}
}

.scene-tags {
	display: flex;
	flex-wrap: wrap;
	gap: 10px;
}

.scene-tag {
	display: inline-flex;
	align-items: center;
	gap: 4px;
	padding: 6px 14px;
	font-size: 13px;
	color: #606266;
	background: #fff;
	border: 1px solid #dcdfe6;
	border-radius: 4px;
	cursor: pointer;
	transition: all 0.2s;
	user-select: none;

	&:hover {
		border-color: #409eff;
		color: #409eff;
	}

	&.active {
		color: #409eff;
		background: #ecf5ff;
		border-color: #409eff;
	}

	i {
		font-size: 12px;
		font-weight: bold;
	}
}

.flag-colors {
	display: flex;
	flex-wrap: wrap;
	gap: 12px;
}

.flag-item {
	display: inline-flex;
	align-items: center;
	gap: 6px;
	cursor: pointer;
	font-size: 13px;
	color: #606266;
	user-select: none;

	input {
		display: none;
	}

	.flag-dot {
		width: 14px;
		height: 14px;
		border-radius: 2px;
		border: 1px solid #dcdfe6;
	}

	&.active {
		color: #409eff;

		.flag-dot {
			box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.3);
		}
	}
}

.form-actions {
	display: flex;
	justify-content: center;
	padding: 24px 0 8px;

	.el-button {
		min-width: 120px;
	}
}
</style>

<style lang="less">
.sku-outer-id-rule-popper {
	max-width: 640px;

	.el-select-dropdown__item {
		height: auto;
		line-height: 1.45;
		white-space: normal;
		padding: 8px 16px;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/StoreConfig/detailed/mSetup.vue